"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uiHelper = void 0;
var handleSwitchStyles = function (_a) {
    var thumb = _a.thumb, thumbActive = _a.thumbActive, track = _a.track, trackActive = _a.trackActive;
    return {
        ".twap-switch": {
            "& .MuiSwitch-thumb": {
                background: thumb,
            },
            "& .MuiSwitch-track": {
                background: "".concat(track, "!important"),
                opacity: "1!important",
            },
            "& .Mui-checked+.MuiSwitch-track": {
                backgroundColor: "".concat(trackActive, "!important"),
                opacity: "1!important",
            },
            "& .Mui-checked .MuiSwitch-thumb": {
                background: thumbActive,
            },
        },
    };
};
exports.uiHelper = {
    handleSwitchStyles: handleSwitchStyles,
};
